import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CompanyService } from '../api/company/company.service';
import { AppRoutes } from '../../app.routes';
import { map, Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class CompanyGuard implements CanActivate {

  constructor(
    private companyService: CompanyService,
    private router: Router
  ) {}
  
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.companyService.currentCompany$.pipe(map(company => {
      if (company) {
        const targetRoute = route.routeConfig?.path;
        const companyRoute = [AppRoutes.Companies, company.uid, targetRoute];
        this.router.navigate(companyRoute, { replaceUrl: true });
        return false;
      }
      return true;
    }));
  }
}
